var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{attrs:{"title":"Invoices"}},[_c('invoices-table',{attrs:{"invoices":_vm.invoices}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }